import { render, staticRenderFns } from "./dashboardCampaignsComponent.vue?vue&type=template&id=2ba7fc9a&scoped=true"
import script from "./dashboardCampaignsComponent.vue?vue&type=script&lang=js"
export * from "./dashboardCampaignsComponent.vue?vue&type=script&lang=js"
import style0 from "./dashboardCampaignsComponent.vue?vue&type=style&index=0&id=2ba7fc9a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ba7fc9a",
  null
  
)

export default component.exports